import { computed, signal, Signal } from '@angular/core';

interface SignalProxy<T> extends Signal<T> {
  connect(source: Signal<T>): void;
}

export function signalProxy<T>(initialValue: T): SignalProxy<T> {
  const signalWrapper = signal<Signal<T> | null>(null);
  const signalValue = computed(() => {
    const wrappedSignal = signalWrapper();
    return wrappedSignal !== null ? wrappedSignal() : initialValue;
  }) as SignalProxy<T>;

  signalValue.connect = (source: Signal<T>): void => signalWrapper.set(source);

  return signalValue;
}
